<template>
  <li class="iw-layout-grid__col--span-6-desktop iw-layout-grid__col--span-4-phone">
    <vendor-menu-item-custom v-bind="$props"></vendor-menu-item-custom>
  </li>
</template>

<script>
import VendorMenuItemCustom from "./templates/VendorMenuItemCustom.vue";

export default {
  name: "VendorMenuItem",
  components: {
    VendorMenuItemCustom
  },
  props: {
    orderId: Number,
    menuItem: Object,
    itemCountUpdated: Function
  }
};
</script>

<style lang="scss" scoped>
li {
  list-style: none;
}
</style>
